'use strict';

import util from './util';

function countrySelector() {

    $('.countries-selector').on('change', function(e) {
        e.preventDefault();

        var countrySelected = $(this).find(':selected').text().toLowerCase();
        if (countrySelected == 'us' || countrySelected == 'united states') {
        	return false;
        }

       
        var countryUrl = $(this).find(':selected').val();
       
        if(window.open(countryUrl, '_blank') == null) {
        	document.location.href = countryUrl;
        }
    });
    
    if($('.country-selector-wrapper').length > 0){
    	
    	var popup = new Foundation.Reveal($('#country-selector-container'));
    	popup.open();    	
    	$('.shopnow-button').on('click', function(){
    		if($(this).closest('#country-selector-container').find('.selectcountry.popup').val() != ''){
    			location = $(this).closest('#country-selector-container').find('.selectcountry.popup').val();
    		}
    	});
    	 
    	
    	$('#country-selector-container').find('.close-button').click(function (e) {
    		var element = e.currentTarget;
        	var marketID = element.dataset.market;
        	var lifetime = element.dataset.countrycookieliftime;
        
        	util.setCookie(SitePreferences.SITEID+'-preferredSite', marketID, lifetime);
    	})
    }
}


function languageSelector() {
    if($('#language-selector-popup').length > 0) {
        var popupdata = $('#language-selector-popup');
		
        var popup = new Foundation.Reveal(popupdata);

        popup.open();
    }
}

export default {
    countrySelector: countrySelector,
    languageSelector: languageSelector
};